import { useThemeVariant } from "@/contexts/ThemeContext";
import { useHeroModel, type HeroModel } from "@/components/home/layouts/models";
import type { HeroEditSlots } from "@/components/home/layouts/shared";
import { ClassicHero } from "@/components/home/layouts/classic";
import { MinimalHero } from "@/components/home/layouts/minimal";
import { WarmHero } from "@/components/home/layouts/warm";
import { BoldHero } from "@/components/home/layouts/bold";
import { ElegantHero } from "@/components/home/layouts/elegant";
import { FreshHero } from "@/components/home/layouts/fresh";
import { ModernHero } from "@/components/home/layouts/modern";

/** Picks the hero composition for the active theme preset. */
export function HeroView({ m, edit }: { m: HeroModel; edit?: HeroEditSlots }) {
  switch (useThemeVariant()) {
    case "modern-minimal": return <MinimalHero m={m} edit={edit} />;
    case "warm-welcome": return <WarmHero m={m} edit={edit} />;
    case "bold-vibrant": return <BoldHero m={m} edit={edit} />;
    case "elegant-serif": return <ElegantHero m={m} edit={edit} />;
    case "fresh-natural": return <FreshHero m={m} edit={edit} />;
    case "modern": return <ModernHero m={m} edit={edit} />;
    default: return <ClassicHero m={m} edit={edit} />;
  }
}

/**
 * Homepage hero. Title / subtitle / CTA / image come from the tenant's
 * homepage content (visual editor); the rating card is computed from their
 * approved reviews and the eyebrow from their service areas. The composition
 * (split, full-bleed, collage, editorial…) follows the theme preset — see
 * `components/home/layouts/`. `edit` lets the page editor swap in inline editors.
 */
export function Hero({ edit }: { edit?: HeroEditSlots }) {
  const m = useHeroModel();
  return <HeroView m={m} edit={edit} />;
}
